export default from './MortgagePayment';



// WEBPACK FOOTER //
// ./src/components/QuizPage/components/SummaryPage/components/MortgagePayment/index.js